import request from "@/utils/request";
import Vue from "vue";
const server = "/business";

//一体化任务管理 风险预警 列表
export function getMessageWorkList(query) {
  return request({
    url: server + "/doctor/messageWork/list",
    method: "post",
    data: query,
  });
}

//一体化任务管理 风险预警 患者消息列表
export function getWarnPatientMessageWorkList(query) {
  const { page, pageSize, ...params } = query;
  // console.warn("query: ", query);
  return request({
    url:
      server +
      "/doctor/messageWork/warnPatients?page=" +
      query.page +
      "&pageSize=" +
      query.pageSize,
    method: "post",
    data: { ...params },
  });
}

//一体化任务管理 风险预警 患者消息列表 点击已读
export function updateMsgStatus(query) {
  return request({
    url: server + "/doctor/messageWork/updateMsgStatus",
    method: "post",
    data: query,
  });
}

//业务监测
export function getBusinessMonitorList(query) {
  return request({
    url: server + `/doctor/businessMonitor`,
    method: "post",
    data: query,
  });
}

//一体化业务数据量
export function getBusinessHomeTips(query) {
  return request({
    url: server + "/doctor/listHomeTips",
    method: "post",
    data: {},
  });
}

//创建患者年度一体化服务方案
export function createIntegratePersonPlan(query) {
  return request({
    url: server + "/integrate/createPersonPlan",
    method: "post",
    data: query,
  });
}

//获取患者年度一体化服务方案
export function getIntegratePersonPlanList(query) {
  return request({
    url: server + "/integrate/getPersonPlanList",
    method: "post",
    data: query,
  });
}

//检查患者一体化服务方案是否存在
export function inspectExistsPersonPlan(query) {
  return request({
    url: server + "/integrate/existsPersonPlan",
    method: "post",
    data: query,
  });
}

//获取患者一体化服务方案详情
export function getPersonAnnualPlan(query) {
  return request({
    url: server + "/integrate/getPersonAnnualPlan",
    method: "post",
    data: query,
  });
}

//获取当前个人一体化方案信息
export function getCurrentPersonPlan(query) {
  return request({
    url: server + "/integrate/getCurrentPersonPlan",
    method: "post",
    data: query,
  });
}

//保存一体化方案信息
export function savePersonPlanItems(query) {
  return request({
    url: server + "/integrate/savePersonPlanItems",
    method: "post",
    data: query,
  });
}

//更新一体化方案名称
export function updatePersonPlanName(query) {
  return request({
    url: server + "/integrate/updatePersonPlanName",
    method: "post",
    data: query,
  });
}

//患者年度方案执行情况接口(所有项目)
export function getPersonPlanExecDetail(query) {
  return request({
    url: server + "/integrate/getPersonPlanExecDetail",
    method: "post",
    data: query,
  });
}

//患者年度方案执行情况接口(某个项目)
export function getPersonPlanItemExecDetail(query) {
  return request({
    url: server + "/integrate/getPersonPlanItemExecDetail",
    method: "post",
    data: query,
  });
}

//获取健康评估项目信息
export function getPersonHealthInfo(query) {
  return request({
    url: server + "/assessment/getPersonHealthInfo",
    method: "post",
    data: query,
  });
}

//获取健康评估结果数据
export function getPersonHealthAssessment(query) {
  return request({
    url: server + "/assessment/getPersonHealthAssessment",
    method: "post",
    data: query,
  });
}

//获取一体化执行时间即将到期的项目列表
export function getUpcomingPlanItemsList(query) {
  return request({
    url: server + "/integrate/getUpcomingPlanItems",
    method: "post",
    data: query,
  });
}

//获取一体化项目枚举接口
export function getIntegrateItemsList() {
  return request({
    url: server + "/integrate/getIntegrateItems",
    method: "post",
    data: {},
  });
}

//获取一体化项目周期接口
export function getIntegratePeriodsList() {
  return request({
    url: server + "/integrate/getIntegratePeriods",
    method: "post",
    data: {},
  });
}
